import * as Account from "../utils/account";
import * as Intercom from "../framework/intercom";
import * as Loading from "../framework/components/loading";
import * as Query from "../framework/query";
import * as StateIndicator from "../framework/components/state_indicator";

export async function init() {
  Account.onDisconnect(Intercom.clearCache);
  Account.onChangeAcademy(Intercom.clearCache);

  const intercomLauncherEls = document.querySelectorAll(".js-intercom-launcher");
  if (intercomLauncherEls.length === 0) return;

  const loadingEls = document.querySelectorAll(".js-intercom-launcher-loading");
  if (isLocalhost()) {
    setLoadersState(loadingEls, "error");
    return;
  }

  try {
    enableElements(intercomLauncherEls);
    toggleClassOnElements(intercomLauncherEls, "button--icon-end", false);
    setLoadersState(loadingEls, "hidden");

    await Intercom.init({ selector: ".js-intercom-launcher" });

    window.Intercom("onUnreadCountChange", (count) => {
      const unreadEls = document.querySelectorAll(".js-intercom-unread-count");
      const isHidden = count === 0;

      for (const unreadEl of unreadEls) {
        StateIndicator.setTodoCount(unreadEl, count);
        unreadEl.classList.toggle("has-hidden", isHidden);
        toggleClassOnElements(intercomLauncherEls, "button--icon-end", !isHidden);
      }
    });

    // We have "intercom_action=compose_new"
    if (Query.getParam("intercom_action") === "compose_new") {
      window.Intercom("showNewMessage");
    }
  } catch (error) {
    console.error("Intercom not initialized", error);
    for (const loadingEl of loadingEls) {
      Loading.setState(loadingEl, "error");
    }
  }
}

function setLoadersState(loadingEls, state) {
  for (const loadingEl of loadingEls) {
    Loading.setState(loadingEl, state);
  }
}

function enableElements(elements) {
  for (const elt of elements) {
    elt.disabled = false;
  }
}

function toggleClassOnElements(elements, className, force) {
  for (const elt of elements) {
    elt.classList.toggle(className, force);
  }
}

function isLocalhost() {
  // Intercom cannot be made to work on localhost. However, it is configured
  // to work on hosts "127.0.0.1" and "app-local.digiforma.com"
  return location.hostname === "localhost";
}
